import dom from '@/util/dom';

var tpl = '<div class="cp-toast cp-toast--start fs-14"><span>{{}}</span></div>';
var activeToast = [];

/**
 * 创建一个toast
 * @param  {String} content toast内容的html
 * @param  {Number} time    toast持续的时间
 * @param  {String} id      toast的id，如果堆栈存在一样的id，则不会新建toast
 */
export default function(content, time, id) {
    if (arguments.length == 2 && typeof time == 'string') {
        id = time;
        time = 3000;
    }

    if (id) {
        if (activeToast.indexOf(id) !== -1) return;
        activeToast.push(id);
    }

    var $toast = dom.create(tpl.replace('{{}}', content));

    time = time || 3000;

    document.body.appendChild($toast);

    $toast.clientHeight;
    $toast.classList.remove('cp-toast--start');

    setTimeout(function() {
        $toast.classList.add('cp-toast--close');
        id && activeToast.splice(activeToast.indexOf(id), 1);

        setTimeout(function () {
            $toast.parentNode.removeChild($toast);
        }, 300);
    }, time);
}



// WEBPACK FOOTER //
// ./src/lib/toast.js